import React from 'react';
import Padding from './Padding';

const About = () => {
    return (
        <section id='About' className="about-section" style={{ backgroundColor: '#050515' }}>
            <Padding />
            <Padding />
            
            <div className="container-text">
                <h2 style={{ marginBottom: '60px' }}>About AJG Software</h2>

                {/* Main Flex Wrapper */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '60px', alignItems: 'flex-start' }}>
                    
                    {/* Left Column: Mission Statement */}
                    <div style={{ flex: '1.5', minWidth: '350px', paddingLeft: '20px' }}>
                        <h3 style={{ textAlign: 'left', marginTop: 0 }}>Global Expertise & Engineering Precision</h3>
                        <p>
                            <strong>Founded in 2023</strong> and based in Cheshire but operating worldwide, 
                            we provide bespoke consultancy and development services that transform 
                            systems into unified, high-performance operations.
                        </p>
                        <p>
                            Our focus is on the seamless integration of industrial hardware with modern 
                            software layers. We specialise in custom-built solutions for environments 
                            where standard "off-the-shelf" products fail to meet the complexity of 
                            the task.
                        </p>
                    </div>

                    {/* Right Column: Key Pillars */}
                    <div style={{ flex: '1', minWidth: '300px' }}>
                        <h3 style={{ textAlign: 'left', marginTop: 0 }}>Why Partner With Us?</h3>
                        <div className="usp-list">
                            <div className="usp-item">
                                <strong>The Full Stack:</strong> 
                                <span>From C#/C++/C to PLC logic to Cloud and AI integration.</span>
                            </div>
                            <div className="usp-item">
                                <strong>Bespoke by Design:</strong> 
                                <span>Tailored solutions, not templates.</span>
                            </div>
                            <div className="usp-item">
                                <strong>Local Expertise:</strong> 
                                <span>Proudly UK-based engineering standards.</span>
                            </div>
                            <div className="usp-item">
                                <strong>Future-Ready:</strong> 
                                <span>Implementing LLMs, Machine Vision, and IoT.</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <Padding />
            <Padding />
        </section>
    );
};

export default About;